import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, distinctUntilChanged, map, Observable, of, shareReplay, switchMap } from 'rxjs';
import { Response } from '@app/core/model';
import { UserService } from '@app/user';
import { AskCaraStatusDto } from '../models/ask-cara-api.dto';
@Injectable({
    providedIn: 'root',
})
export class AskCaraStatusService {
    private readonly httpClient = inject(HttpClient);
    private readonly userService = inject(UserService);

    readonly enabled$: Observable<boolean> = this.userService.user$.pipe(
        map((user) => user?.id ?? null),
        distinctUntilChanged(),
        switchMap((userId) => (userId ? this.fetchEnabled() : of(false))),
        shareReplay({ bufferSize: 1, refCount: false }),
    );

    private fetchEnabled(): Observable<boolean> {
        return this.httpClient
            .skipErrorHandler()
            .get<Response<AskCaraStatusDto>>('api/v2.10/cara/chat/status')
            .pipe(
                map((res) => res.data.enabled),
                catchError(() => of(false)),
            );
    }
}
